<template>
  <div class="container-fluid">
    <mdb-container>
      <mdb-row>
        <mdb-card-title>
          <strong> Add or Remove Stations</strong>
        </mdb-card-title>
      </mdb-row>

      <mdb-row>
        <StationsConfig />
      </mdb-row>
    </mdb-container>
  </div>
</template>

<script>
import StationsConfig from "@/components/StationsConfig";
import { mdbCardTitle, mdbRow, mdbContainer } from "mdbvue";

export default {
  name: "Stations",
  components: {
    StationsConfig,
    mdbCardTitle,
    mdbRow,
    mdbContainer,
  },
  data() {
    return {
      isLoading: false,
    };
  },
  created() {},
  computed: {},
  methods: {},
};
</script>

<style scoped lang="scss"></style>
